import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";

const headingSizeClasses = {
  1: "text-4xl tracking-tight",
  2: "text-3xl tracking-tight",
  3: "text-2xl tracking-[-0.0125em]",
  4: "text-xl",
  5: "text-lg",
  6: "text-base",
} as const;

const headingWeightClasses = {
  medium: "font-medium",
  regular: "font-normal",
  semibold: "font-semibold",
} as const;

type HeadingSize = keyof typeof headingSizeClasses;
type HeadingWeight = keyof typeof headingWeightClasses;

export interface HeadingProps extends ComponentPropsWithoutRef<"h1"> {
  as: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  size?: HeadingSize;
  truncate?: boolean;
  weight?: HeadingWeight;
}

export function Heading({
  as: Component,
  size,
  weight = "medium",
  truncate,
  className,
  ...rest
}: HeadingProps) {
  return (
    <Component
      className={cn(
        size && headingSizeClasses[size],
        headingWeightClasses[weight],
        truncate && "truncate",
        className
      )}
      data-heading=""
      {...rest}
    />
  );
}
